export default {
  state: {
    title: 'Stato',
    visible: 'Ordini al tavolo visibili',
    on: 'Ordini al tavolo',
  },
  notes: {
    hidden: {
      title: "L'ordinazione al tavolo è nascosta",
      description:
        'È attiva, ma il tuo negozio non la mostra, quindi ogni ordine al tavolo viene rifiutato. Attiva «Ordinazione al tavolo visibile» per mostrarla.',
      link: "Vai all'interruttore",
    },
    off: {
      title: 'Al momento gli ospiti non possono ordinare al tavolo',
      description:
        'Attiva entrambi gli interruttori per iniziare. Fino ad allora, il codice QR di un tavolo apre il tuo negozio con Ritiro e Consegna.',
    },
    no_active_table: {
      title: 'Gli ospiti non possono ancora ordinare al tavolo',
      description: 'Aggiungi un tavolo qui sotto e attivalo.',
    },
  },
  buttons: {
    save: 'Salva',
  },
};
